import React from "react";

import styles from "../styles.module.css";
import { SparkLineCell } from "~components/TickerChart";
import { useTickerChartData } from "~hooks/ticker-chart";
import type { PricePoint } from "~types/types";

const SPARKLINE_WIDTH = 80;
const SPARKLINE_HEIGHT = 32;

interface RenderSparkLineProps {
  readonly ticker: string;
}

export default function RenderSparkLine({
  ticker,
}: RenderSparkLineProps): React.ReactElement {
  const { data, isPending } = useTickerChartData([ticker], "1D");

  if (isPending) {
    return (
      <div
        className={styles.skeleton}
        style={{ width: SPARKLINE_WIDTH, height: SPARKLINE_HEIGHT }}
        aria-label={`Loading ${ticker} sparkline`}
        role="status"
      />
    );
  }

  const series = data?.[0];
  const priceMovements = (series?.priceMovements ?? []) as PricePoint[];

  if (priceMovements.length === 0) {
    return <span className={styles.tertiary}>—</span>;
  }

  return (
    <SparkLineCell
      data={priceMovements}
      width={SPARKLINE_WIDTH}
      height={SPARKLINE_HEIGHT}
      previousClose={series?.previousClose}
      showBaseline={true}
      accessibilityLabel={`${ticker} sparkline`}
    />
  );
}
